import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { requiredIf, email } from 'vuelidate/lib/validators';
import PaymentOptionFormMixin from '@/helpers/vue_mixins/v2/PaymentOptionFormMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import SavePartnerAccount from '@/plugins/graphql/mutations/v2/save-partner-account.gql';
import CreatePartnerAccount from '@/plugins/graphql/mutations/v2/create-partner-account.gql';
import PartnerAccount from '@/plugins/graphql/queries/fetch-partner-account.gql';
import Modal from '@/components/v3/Modal.vue';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import { requiredProperty, invalidType } from '@/helpers/mixins/LocalizationHelper';
import appBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
let PaymentOptionFormXendit = class PaymentOptionFormXendit extends mixins(PaymentOptionFormMixin, RouterParamsAppMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            businessName: this.$store.state.appName,
            xenditId: '',
            memberEmail: [],
        };
        this.paymentOptionDetails = {
            businessName: '',
            email: '',
            status: '',
        };
        this.hasXenditAccount = true;
        this.confirmXenditLinking = false;
    }
    get youtubeIcon() {
        return require('@/assets/icons/youtube.svg');
    }
    onCancel() {
        this.confirmXenditLinking = false;
    }
    toggleConfirmation() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.confirmXenditLinking = true;
        }
    }
    async onSubmit() {
        this.requestOnFlight();
        const mutation = () => this.hasXenditAccount ? this.savePartnerAccount() : this.createPartnerAccount();
        await mutation()
            .then((data) => {
            this.requestDone();
            if (!this.paymentGateway.paymentOption) {
                this.$emit('xenditSuccess');
            }
            else {
                this.success();
                if (data.data.savePartnerAccount) {
                    this.successNotification('Successfully Updated Xendit Account');
                }
                else {
                    this.successNotification('Xendit Account Created Successfully');
                }
                this.confirmXenditLinking = false;
                this.$emit('cancel');
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.logError(e.message);
            this.requestDone();
            this.$emit('cancel');
        });
        // this.$emit('xenditSuccess');
    }
    savePartnerAccount() {
        return this.$apollo.mutate({
            mutation: SavePartnerAccount,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    accountId: this.form.xenditId,
                },
            },
        });
    }
    createPartnerAccount() {
        return this.$apollo.mutate({
            mutation: CreatePartnerAccount,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    businessName: this.form.businessName,
                    memberEmail: this.form.memberEmail.join(','),
                },
            },
        });
    }
    get xenditIdErrors() {
        const errors = [];
        if (!this.$v.form.xenditId.$dirty) {
            return errors;
        }
        if (!this.$v.form.xenditId.required) {
            const msg = requiredProperty('Business ID');
            errors.push(msg);
        }
        return errors;
    }
    get businessNameErrors() {
        const errors = [];
        if (!this.$v.form.businessName.$dirty) {
            return errors;
        }
        if (!this.$v.form.businessName.required) {
            const msg = requiredProperty('Business Name');
            errors.push(msg);
        }
        return errors;
    }
    get memberEmailErrors() {
        const errors = [];
        if (!this.$v.form.memberEmail.$dirty) {
            return errors;
        }
        if (!this.$v.form.memberEmail.required) {
            const msg = requiredProperty('Email');
            errors.push(msg);
        }
        return errors;
    }
    get header() {
        if (this.paymentGateway.paymentOption) {
            return 'Xendit Payment Gateway Edit';
        }
        if (this.hasXenditAccount) {
            return 'Xendit Payment Gateway Activation';
        }
        return `Don't have a Xendit account yet?`;
    }
    get textInfo() {
        if (this.hasXenditAccount && !this.paymentGateway.paymentOption) {
            return 'If you already have a Xendit account connected to ChatGenie, provide the Xendit Account Business ID below.';
        }
        if (!this.hasXenditAccount && !this.paymentGateway.paymentOption) {
            return 'If you do not have a Xendit account connected to ChatGenie, update your business name below and we will create an account for you.';
        }
        if (this.hasXenditAccount && this.paymentGateway.paymentOption) {
            return 'If you want to replace your current Xendit account linked to ChatGenie with another connected account, please enter the replacement Xendit Account Business ID below.';
        }
        return `If you want to replace your current Xendit account linked to ChatGenie with a different one but don't have another account already connected, please update your business name below and we will create an account for you.`;
    }
    get toggleText() {
        if (this.hasXenditAccount) {
            return `Don't have a Xendit account yet? Click`;
        }
        return 'Already have a Xendit account? Click';
    }
    toggleForm() {
        this.$v.$reset();
        this.form.businessName = this.$store.state.appName;
        this.form.xenditId = '';
        this.hasXenditAccount = !this.hasXenditAccount;
    }
    getEmailErrors(emailList, emailType, emailTypeSpace) {
        const errors = [];
        let hasWhitespace = false;
        if (emailList.some((emailAddr) => this.trailingWhitespace(emailAddr))) {
            hasWhitespace = true;
            errors.push('Invalid input. Please make sure that there are no whitespaces before or after the email addresses provided');
        }
        if (!hasWhitespace && this.$v.form[emailType].$anyError) {
            errors.push(invalidType(emailTypeSpace));
        }
        return errors;
    }
    get trailingWhitespace() {
        return (value) => {
            if (typeof value !== 'string')
                return false;
            return value.trim() !== value;
        };
    }
    get tooltipText() {
        return `Enter the email address you want to be added as a member to your Xendit dashboard. This will allow you to manage your Xendit account directly`;
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], PaymentOptionFormXendit.prototype, "paymentGateway", void 0);
PaymentOptionFormXendit = __decorate([
    Component({
        apollo: {
            fetchPartnerAccount: {
                query: PartnerAccount,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                fetchPolicy: 'network-only',
                update(data) {
                    if (data.fetchPartnerAccount) {
                        this.paymentOptionDetails.email = data.fetchPartnerAccount.email;
                        this.paymentOptionDetails.status = data.fetchPartnerAccount.status;
                        this.paymentOptionDetails.businessName = data.fetchPartnerAccount.businessName;
                        this.paymentOptionDetails.businessName = data.fetchPartnerAccount.businessName;
                        const { memberEmail } = data.fetchPartnerAccount;
                        this.form.memberEmail = typeof memberEmail === 'string' ? memberEmail.split(',') : [];
                    }
                },
            },
            app: {
                query: appBasic,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    if (!this.form.memberEmail || this.form.memberEmail.length === 0) {
                        this.form.memberEmail = data.app.user.businessEmailAddress
                            ? [...data.app.user.businessEmailAddress.split(',')]
                            : [];
                    }
                    return data.app;
                },
            },
        },
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
            Modal,
            ToggleConfirmationDialog,
        },
        validations() {
            const vm = this;
            return {
                form: {
                    businessName: {
                        required: requiredIf(() => !vm.hasXenditAccount),
                    },
                    memberEmail: {
                        required: requiredIf(() => !vm.hasXenditAccount),
                        $each: {
                            email,
                        },
                    },
                    xenditId: {
                        required: requiredIf(() => vm.hasXenditAccount),
                    },
                },
            };
        },
    })
], PaymentOptionFormXendit);
export default PaymentOptionFormXendit;
